// extracted by mini-css-extract-plugin
export default {"polygonContainer":"Polygon_polygonContainer__Y74nD","aktivPolygon":"Polygon_aktivPolygon__dl0iF"};